import b from 'b_';
import cx from 'classnames';
import { StarFilled as Star } from 'education-icons';
import { SPIN_SIZES } from 'platform-components/src/components/spin/constants';
import Spin from 'platform-components/src/components/spin/spin';
import React from 'react';

// @ts-ignore
import COLORS from '../../design/colors';

import './class-avatar.scss';

import { CLASS_AVATAR_SIZES } from './typings';

interface iClassAvatarProps {
    id: number;
    level?: number;
    mix?: string;
    size?: CLASS_AVATAR_SIZES;
    withStar?: boolean;
    syncing?: boolean;
}

export class ClassAvatar extends React.Component<iClassAvatarProps> {
    static defaultProps = {
        size: CLASS_AVATAR_SIZES.LARGE,
    };

    static SIZES = CLASS_AVATAR_SIZES;

    getAvatarColor = (id: number) => {
        const colors = [
            {
                backgroundColor: COLORS.jeans,
                color: COLORS.white,
            },
            {
                backgroundColor: COLORS.green,
                color: COLORS.white,
            },
            {
                backgroundColor: COLORS.red,
                color: COLORS.white,
            },
            {
                backgroundColor: COLORS.alice,
                color: COLORS.white,
            },
            {
                backgroundColor: COLORS.yellow500,
                color: COLORS.black900,
            },
            {
                backgroundColor: COLORS.wave,
                color: COLORS.black900,
            },
        ];
        const colorsLength = colors.length;

        return colors[id % colorsLength];
    };

    render() {
        const { level = '', id, size, mix, withStar, syncing } = this.props;
        const colors = this.getAvatarColor(id);

        const avatarText = level === 99 ? 'СПО' : level;

        return (
            <div className={cx('class-avatar__wrapper', mix)}>
                <div className={b('class-avatar', { size, syncing })} style={syncing ? {} : colors}>
                    {syncing ? (
                        <Spin mix={b('class-avatar', 'spin', { size })} size={SPIN_SIZES.XS} />
                    ) : (
                        <span className="class-avatar__element">{avatarText}</span>
                    )}
                </div>
                {withStar && <Star className="class-avatar__star" />}
            </div>
        );
    }
}

export default ClassAvatar;
